// Feature-local helpers for /map progressive page accumulation (B3).
// Pure functions only — no React, no network, no Leaflet.

export const MARKER_PAGE_SIZE = 100;

export function unwrapPaginatedList(data) {
  if (Array.isArray(data)) {
    return {
      results: data,
      count: data.length,
      hasNextField: false,
      next: null,
    };
  }
  if (data && Array.isArray(data.results)) {
    const hasNextField = Object.prototype.hasOwnProperty.call(data, "next");
    return {
      results: data.results,
      count: data.count ?? data.results.length,
      hasNextField,
      next: hasNextField ? data.next : null,
    };
  }
  return { results: [], count: 0, hasNextField: false, next: null };
}

export function deriveHasNext(unwrapped, accumulatedCount) {
  if (unwrapped && unwrapped.hasNextField) {
    return unwrapped.next != null && unwrapped.next !== "";
  }
  const total = unwrapped && unwrapped.count;
  return typeof total === "number" && accumulatedCount < total;
}

export function propertyRowId(row) {
  if (!row || row.id === null || row.id === undefined || row.id === "") {
    return null;
  }
  return row.id;
}

export function accumulatePropertyRows(existing, incoming) {
  const seen = new Set();
  const out = [];

  const push = (row) => {
    const id = propertyRowId(row);
    if (id === null) {
      out.push(row);
      return;
    }
    if (seen.has(id)) return;
    seen.add(id);
    out.push(row);
  };

  for (const row of existing || []) push(row);
  for (const row of incoming || []) push(row);
  return out;
}

export function parseMapCoordinate(value) {
  if (value === null || value === undefined || value === "") return null;
  const n = Number(value);
  return Number.isFinite(n) ? n : null;
}

export function propertyHasValidCoordinates(property) {
  const loc = (property && property.location) || {};
  return (
    parseMapCoordinate(loc.latitude) !== null
    && parseMapCoordinate(loc.longitude) !== null
  );
}

export function isMapFetchAbortError(error) {
  if (!error) return false;
  return (
    error.name === "AbortError"
    || error.name === "CanceledError"
    || error.code === "ERR_CANCELED"
  );
}
